export default function htmlTextParser(string) {
  if (!string) return []
  const results = []
  const regex = /<(\w+)[^>]*>(.*?)<\/\1>/g

  let match
  while ((match = regex.exec(string)) !== null) {
    const content = match[2]

    results.push(content)
  }

  return results.length ? results : [string]
}
